import { ROUTES } from "../../../../module/constants";
import { generalConst } from "../../../../module/globalInterface";

export const TEMPLATE_MAIL_MGMT_CONSOLE_ADMIN_URLS: generalConst = {
  BASE_URL: ROUTES.ADMIN_TEMPLATE_MAIL_MGMT,
  STEP_TWO_CREATE: `${ROUTES.ADMIN_TEMPLATE_MAIL_MGMT}/stepTwoCreate`,
  STEP_TWO_MODIFY: `${ROUTES.ADMIN_TEMPLATE_MAIL_MGMT}/stepTwoModify`,
};

export const STATE_IDENTIFIER = {
  STEP_ONE: "stepOne",
  STEP_TWO: "stepTwo",
  TEMPLATE_MAIL_TABLE: "templateMailTable",
  TEMPLATE_MAIL_DETAIL: "templateMailDetail",
  REQUEST_STATE: "requestState",
};

export const LIST_IDENTIFIER: string = "list";
export const LOADER_IDENTIFIER: string = "loader";

export interface IMailTable {
  id: string;
  subject: string;
  max_retry: string;
}

export interface IMailObject {
  id: number | null;
  operation: string;
  subject: string;
  to: string;
  cc: string;
  ccn: string;
  body: string;
  maxRetry: number;
  retryDelay: number;
}

export interface ITemplateMailObject {
  templates: IMailObject[];
}
